import React, { ReactNode, createContext } from 'react'

export interface RosterTableProviderProps {
    children?: ReactNode
}

interface RosterTableContextValue {
    currentRosterCandidateId: string | undefined
    setCurrentRosterCandidateId: (id?: string) => void
}

export const RosterTableContext = createContext<RosterTableContextValue>({
    currentRosterCandidateId: undefined,
    setCurrentRosterCandidateId: () => {},
})

const RosterTableProvider: React.FC<RosterTableProviderProps> = ({
    children,
}: RosterTableProviderProps) => {
    const [currentRosterCandidateId, setCurrentRosterCandidateId] =
        React.useState<string | undefined>(undefined)
    const setCurrentRosterCandidateIdHandler = (id?: string) => {
        setCurrentRosterCandidateId(id)
    }

    return (
        <RosterTableContext.Provider
            value={{
                currentRosterCandidateId: currentRosterCandidateId,
                setCurrentRosterCandidateId: setCurrentRosterCandidateIdHandler,
            }}
        >
            {children}
        </RosterTableContext.Provider>
    )
}

export default RosterTableProvider
